import React from "react";
import { connect } from "react-redux";
import { withWrapper } from "create-react-server/wrapper";
import { bindActionCreators } from "redux";
import events from "modules/events";
import specials from "modules/specials";

import "./AfishaSelections.css";

import DatesButtons from "./DatesButtons";
import TypesButtons from "./TypesButtons";
// import OptionsButton from "./OptionsButton";
import ChangeViewBtn from "./ChangeViewBtn";

class AfishaSelections extends React.Component {
  state = {
    options: null,
    types: null,
    dates: null,
    filters: {
      date_times: null,
      types: null,
      options: {
        has_gifts: null,
        for_children: null
      },
      query: null
    },
    typesOpen: false,
    hideBtn: "hide",
    activeType: [{ type: 0 }],
    changeViewData: [
      { id: 0, text: "Списком", classObject: "--active" },
      { id: 1, text: "На карте", classObject: "" }
    ]
  };

  componentWillUpdate(nextProps) {
    let { changedInterval } = nextProps;

    if (changedInterval !== this.props.changedInterval) {
      const {
        filters: { date_times, types, options }
      } = this.state;
      const { query, btn_dates } = this.props;

      this.getFilteredData(
        date_times,
        types,
        options,
        query,
        btn_dates,
        changedInterval
      );
    }

    if ((nextProps.query || !nextProps.query) && nextProps.entered) {
      const {
        filters: { date_times, types, options }
      } = this.state;
      const { btn_dates, timeInterval } = this.props;

      this.getFilteredData(
        date_times,
        types,
        options,
        nextProps.query,
        btn_dates,
        timeInterval
      );
    }

    if (nextProps.reset) {
      const { btn_dates, times } = this.props;

      this.getFilteredData(null, null, null, null, btn_dates, times);
      this.setState({
        options: null,
        dates: this.definePropertyClassBtn(0, "dates"),
        types: this.definePropertyTypesClassBtn(0),
        filters: {
          date_times: null,
          types: null,
          options: {
            has_gifts: null,
            for_children: null
          },
          query: null
        }
      });

      this.props.resetSpecials();
    }
  }

  getFilteredData = (
    date_times,
    types,
    options,
    query,
    btn_dates,
    timeInterval
  ) => {
    let arr = [];
    let opt;

    if (!date_times) {
      for (let i = 0; i < btn_dates.length; i++) {
        arr.push({
          start_begin: `${btn_dates[i].id} ${timeInterval[0]}`,
          start_end: `${btn_dates[i].id} ${timeInterval[1]}`
        });
      }
    } else {
      arr.push({
        start_begin: `${date_times} ${timeInterval[0]}`,
        start_end: `${date_times} ${timeInterval[1]}`
      });
    }

    if (options) {
      if (options.has_gifts && options.for_children) {
        opt = { has_gifts: true, for_children: true };
      } else if (options.has_gifts && !options.for_children) {
        opt = { has_gifts: true };
      } else if (!options.has_gifts && options.for_children) {
        opt = { for_children: true };
      } else {
        opt = null;
      }
    } else {
      opt = null;
    }

    let str = {
      query: query ? query : null,
      date_times: arr,
      types: types ? [`${types}`] : null,
      options: opt,
      page: 1
    };

    this.props.postEvents(this.props.match.params.id || 3, str);
  };

  getDatesData = () => {
    let datesData;

    for (let i = 0; i < this.props.btn_dates.length; i++) {
      datesData = this.props.btn_dates
        .map(btn => {
          return Object.defineProperty(btn, "classObject", {
            value: "",
            enumerable: true,
            configurable: true
          });
        })
        .concat({
          id: "Все дни",
          text: "Все дни",
          classObject: "--active"
        })
        .reverse();
    }

    this.setState({
      dates: datesData
    });
  };

  getTypesData = () => {
    let typesData;

    for (let i = 0; i < this.props.btn_types.length; i++) {
      typesData = this.props.btn_types
        .map(btn => {
          return Object.defineProperty(btn, "classObject", {
            value: "",
            enumerable: true,
            configurable: true
          });
        })
        .reverse()
        .concat({
          id: "Все читальни",
          text: "Все читальни",
          classObject: "--active"
        })
        .reverse();
    }

    this.setState({
      types: typesData
    });
  };

  // getOptionsData = () => {
  //   let optionsData;
  //
  //   for (let i = 0; i < this.props.btn_options.length; i++) {
  //     optionsData = this.props.btn_options.map(btn => {
  //       return Object.defineProperty(btn, "classObject", {
  //         value: "",
  //         enumerable: true,
  //         configurable: true
  //       });
  //     });
  //   }
  //
  //   this.setState({
  //     options: optionsData
  //   });
  // };

  onDatesBtnClick = (id, value, name, text) => {
    const {
      filters: { types, options }
    } = this.state;
    const { query, btn_dates, timeInterval } = this.props;

    this.setState(
      state => ({
        dates: this.definePropertyClassBtn(id, name),
        filters: {
          date_times: value === "Все дни" ? "" : value,
          types: state.filters.types,
          options: state.filters.options
        }
      }),
      () => {
        this.getFilteredData(
          value === "Все дни" ? "" : value,
          types,
          options,
          query,
          btn_dates,
          timeInterval
        );
      }
    );

    this.props.getDateArray(text.replace(/,.*/g, ""));
  };

  // onOptionsBtnClick = (id, value, name, text) => {
  //   const {
  //     filters: { date_times, types, options }
  //   } = this.state;
  //   const { query, btn_dates, timeInterval } = this.props;
  //   this.setState(
  //     state => ({
  //       options: this.definePropertyClassBtn(id, name),
  //       filters: {
  //         date_times: state.filters.date_times,
  //         types: state.filters.types,
  //         options: {
  //           has_gifts:
  //             value === "has_gifts"
  //               ? !state.filters.options.has_gifts
  //               : state.filters.options.has_gifts,
  //           for_children:
  //             value === "for_children"
  //               ? !state.filters.options.for_children
  //               : state.filters.options.for_children
  //         }
  //       }
  //     }),
  //     () => {
  //       this.getFilteredData(
  //         date_times,
  //         types,
  //         options,
  //         query,
  //         btn_dates,
  //         timeInterval
  //       );
  //     }
  //   );
  //
  //   this.props.getSelectedButtons(text);
  // };

  onChangeViewBtnClick = id => {
    this.setState({
      changeViewData: this.definePropertyChangeViewClassBtn(id)
    });
  };

  definePropertyChangeViewClassBtn = id => {
    const { changeViewData } = this.state;

    return Object.keys(changeViewData).map((key, i) => {
      let prop = Object.getOwnPropertyDescriptor(
        changeViewData[key],
        "classObject"
      ).value;

      if (i === id && !prop) this.props.changeSpecialsView();

      return i !== id && prop
        ? Object.defineProperty(changeViewData[key], "classObject", {
            value: ""
          })
        : i === id && !prop
        ? Object.defineProperty(changeViewData[key], "classObject", {
            value: "--active"
          })
        : changeViewData[key];
    });
  };

  onClickTypesOpen = () => {
    this.setState(state => ({
      typesOpen: !state.typesOpen,
      hideBtn: state.hideBtn === "" ? "hide" : ""
    }));
  };

  onTypesBtnClick = (id, value) => {
    value = value !== "Все читальни" ? value : "";

    this.setState(state => ({
      types: this.definePropertyTypesClassBtn(id, value),
      filters: {
        date_times: state.filters.date_times,
        types: value,
        options: state.filters.options
      }
    }));

    this.props.getSelectedButtons(value);
  };

  definePropertyTypesClassBtn = (id, value) => {
    const {
      filters: { date_times, options },
      types,
      activeType
    } = this.state;
    const { query, btn_dates, timeInterval } = this.props;
    let isTypesReseted = false;
    let typesArray = activeType;

    if (id === 0) {
      this.setState({ activeType: [{ type: 0 }] });

      isTypesReseted = true;
    } else {
      typesArray.forEach(element => {
        if (typesArray) {
          if (element.type === id) {
            this.setState({
              activeType:
                typesArray.length === 1
                  ? [{ type: 0 }]
                  : typesArray.filter(arr => arr.type !== id)
            });

            isTypesReseted = typesArray.length === 1;
            typesArray = null;
          } else {
            this.setState({
              activeType: [
                ...typesArray.filter(arr => arr.type !== 0),
                { type: id }
              ]
            });

            isTypesReseted = false;
          }
        }
      });
    }

    value = isTypesReseted ? "" : value;

    this.getFilteredData(
      date_times,
      value,
      options,
      query,
      btn_dates,
      timeInterval
    );

    // временная функция
    return Object.keys(types).map((key, i) => {
      let prop = Object.getOwnPropertyDescriptor(types[key], "classObject")
        .value;

      return i !== id && prop
        ? Object.defineProperty(types[key], "classObject", {
            value: ""
          })
        : i === 0 && id !== 0 && prop
        ? Object.defineProperty(types[key], "classObject", {
            value: ""
          })
        : i === id && !prop
        ? Object.defineProperty(types[key], "classObject", {
            value: "--active"
          })
        : types[key];
    });

    // return Object.keys(types).map((key, i) => {
    //   let prop = Object.getOwnPropertyDescriptor(types[key], "classObject")
    //     .value;
    //
    //   return i === 0 && isTypesReseted
    //     ? Object.defineProperty(types[key], "classObject", {
    //         value: "--active"
    //       })
    //     : i === id && !prop
    //     ? Object.defineProperty(types[key], "classObject", {
    //         value: "--active"
    //       })
    //     : (i === id && i !== 0 && prop) ||
    //       (i === 0 && id !== 0 && prop) ||
    //       (i !== 0 && isTypesReseted)
    //     ? Object.defineProperty(types[key], "classObject", {
    //         value: ""
    //       })
    //     : types[key];
    // });
  };

  definePropertyClassBtn = (id, name) => {
    const { dates, options } = this.state;
    let names = name === "dates" ? dates : options;

    return Object.keys(names).map((key, i) => {
      let prop = Object.getOwnPropertyDescriptor(names[key], "classObject")
        .value;

      if (name === "dates") {
        return i !== id && prop
          ? Object.defineProperty(names[key], "classObject", {
              value: ""
            })
          : i === 0 && id !== 0 && prop
          ? Object.defineProperty(names[key], "classObject", {
              value: ""
            })
          : i === id && !prop
          ? Object.defineProperty(names[key], "classObject", {
              value: "--active"
            })
          : names[key];
      }

      // if (name === "options") {
      //   return i === id && prop
      //     ? Object.defineProperty(names[key], "classObject", {
      //         value: ""
      //       })
      //     : i === id && !prop
      //     ? Object.defineProperty(names[key], "classObject", {
      //         value: "--active"
      //       })
      //     : names[key];
      // }
    });
  };

  render() {
    const {
      dates,
      // options,
      types,
      typesOpen,
      hideBtn,
      // activeType,
      changeViewData
    } = this.state;
    const {
      clientWidth,
      isPartnerSelected,
      onPartnerBtnClick,
      isSpecialOffersSelected,
      onSpecialOffersBtnClick
    } = this.props;

    return (
      <div className="afisha-search_selection">
        {dates ? (
          <DatesButtons dates={dates} onDatesBtnClick={this.onDatesBtnClick} />
        ) : (
          this.props.btn_dates && this.getDatesData()
        )}
        <div className="afisha-search_selection__types-container">
          {/* {options ? (
            <OptionsButton
              options={options}
              onOptionsBtnClick={this.onOptionsBtnClick}
            />
          ) : (
            this.props.btn_options && this.getOptionsData()
          )} */}
          {/*{!clientWidth && (*/}
          {/*  <div className="afisha-search_selection__partners">*/}
          {/*    <button*/}
          {/*      onClick={() => onPartnerBtnClick()}*/}
          {/*      style={{*/}
          {/*        ...partnerBtnStyle,*/}
          {/*        backgroundColor: "rgba(153, 204, 204, 0.3)",*/}
          {/*        border: isPartnerSelected*/}
          {/*          ? "2px solid #FF0000"*/}
          {/*          : "2px solid rgba(186, 186, 194, 0.5)"*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      Партнеры*/}
          {/*    </button>*/}
          {/*    <button*/}
          {/*      onClick={() => onSpecialOffersBtnClick()}*/}
          {/*      style={{*/}
          {/*        ...partnerBtnStyle,*/}
          {/*        backgroundColor: "#F9EED2",*/}
          {/*        border: isSpecialOffersSelected*/}
          {/*          ? "2px solid #FFCC00"*/}
          {/*          : "2px solid rgba(186, 186, 194, 0.5)"*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      Спецпредложения*/}
          {/*    </button>*/}
          {/*  </div>*/}
          {/*)}*/}
          {types ? (
            <TypesButtons
              onTypesBtnClick={this.onTypesBtnClick}
              onClickTypesOpen={this.onClickTypesOpen}
              typesOpen={typesOpen}
              hideBtn={hideBtn}
              types={types}
              clientWidth={clientWidth}
            />
          ) : (
            this.props.btn_types && this.getTypesData()
          )}
          {/*{clientWidth && (*/}
          {/*  <div className="afisha-search_selection__partners">*/}
          {/*    <button*/}
          {/*      onClick={() => onPartnerBtnClick()}*/}
          {/*      style={{*/}
          {/*        ...partnerBtnStyle,*/}
          {/*        backgroundColor: "rgba(153, 204, 204, 0.3)",*/}
          {/*        border: isPartnerSelected*/}
          {/*          ? "2px solid #FF0000"*/}
          {/*          : "2px solid rgba(186, 186, 194, 0.5)"*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      Партнеры*/}
          {/*    </button>*/}
          {/*    <button*/}
          {/*      onClick={() => onSpecialOffersBtnClick()}*/}
          {/*      style={{*/}
          {/*        ...partnerBtnStyle,*/}
          {/*        backgroundColor: "#F9EED2",*/}
          {/*        border: isSpecialOffersSelected*/}
          {/*          ? "2px solid #FFCC00"*/}
          {/*          : "2px solid rgba(186, 186, 194, 0.5)"*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      Спецпредложения*/}
          {/*    </button>*/}
          {/*  </div>*/}
          {/*)}*/}
          <ChangeViewBtn
            changeViewData={changeViewData}
            onChangeViewBtnClick={this.onChangeViewBtnClick}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  btn_types: state.specials.types,
  btn_dates: state.specials.dates,
  btn_options: state.specials.options,
  reset: state.specials.reset,
  times: state.specials.times,

  pages: state.events.pages
});

const mapDispatchToProps = dispatch => ({
  postEvents: bindActionCreators(events.actions.postEvents, dispatch),
  resetSpecials: bindActionCreators(specials.actions.resetSpecials, dispatch),
  changeSpecialsView: bindActionCreators(
    specials.actions.changeSpecialsView,
    dispatch
  )
});

export default withWrapper(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AfishaSelections)
);

const partnerBtnStyle = {
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: "normal",
  fontSize: "14px",
  lineHeight: "normal",

  color: "#2B2B2B",
  boxSizing: "border-box",
  borderRadius: "5px",
  minWidth: "86px",
  height: "30px"
};



// WEBPACK FOOTER //
// ./src/components/Events/AfishaSelections.js